import PageResponse from '../CRM/Responses/PageResponse';

import Model from './Model';

export default class Page extends Model {
    readonly id: number;
    readonly name: string = '';
    readonly route: string = '';
    readonly route_parameters: string[] = [];
    readonly type: string = '';
    readonly is_active: boolean = true;

    constructor(page: Partial<PageResponse>) {
        super();
        this.assignDataToProps(page, ['id', 'name', 'route', 'route_parameters', 'type', 'is_active']);
    }
}
